import { render, staticRenderFns } from "./HomeIM.vue?vue&type=template&id=372b9040&"
import script from "./HomeIM.vue?vue&type=script&lang=js&"
export * from "./HomeIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports